import React from 'react'
import styled from 'styled-components'
import SkillItems from './SkillItems'
import {FaChalkboardTeacher} from 'react-icons/fa';

export default function Skills() {
    const skillList = [
        {
            name: "HTML",
            level: "80"
        },
        {
            name: "CSS",
            level: "80"
        },
        {
            name: "JAVASCRIPT",
            level: "75"
        },
        {
            name:'TYPESCRIPT',
            level:'70'
        },
        {
            name: 'ANGULAR TS',
            level: "80"
        },
        {
            name: "REACT JS",
            level: "65"
        },
        {
            name: "NODE JS",
            level: "60"
        },
        {
            name: "JAVA",
            level: "70"
        }
    ]
    return (
        <Wrapper id='skills'>
            <h3 className="section-heading ">
                <span><FaChalkboardTeacher /></span>
                <span>SKILLS</span>
            </h3>
            <div className="skills-display">
                {
                    skillList.map((elem)=>{
                        return <SkillItems key={elem.name} data={elem} />
                    })
                }
            </div>
        </Wrapper>
    )
}

const Wrapper=styled.div`
    padding-bottom: 5rem;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 40px auto;
    background-color: #1d1c21;

.section-heading {
    width: auto;
    padding: 20px 10px 10px;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: center;
}

.section-heading span {
    font-size: 40px;
    color: var(--section-color);
    padding-top: 10px;
    display: flex;
    align-items: center;
    margin-right: .5rem;
}


.skills-display {
    width: 70%;
    display: flex;
    flex-wrap: wrap;
    gap: 2rem 6rem;
    justify-content: space-around;
}

.skill-progress {
    background-color: rgb(185, 185, 185);
    border-radius: 15px;
    width: 15rem;
    height: 2rem;
    border: 1px solid rgb(156, 156, 156);
    transition: all .5s ease-in-out;
}

.html-skill, .css-skill, .javascript-skill, .reactjs-skill, .nodejs-skill, .java-skill,.typescript-skill,.angularts-skill{
    color: white;
    background-color: rgba(0, 201, 201, 0.678);
    height: 100%;
    width: 0;
    border-bottom-left-radius: 15px;
    border-top-left-radius: 15px;
}

.css-skill{
    background-color: rgba(154, 0, 201, 0.678);
}

.javascript-skill{
    background-color: rgba(0, 201, 44, 0.678);
}

.typescript-skill{
    background-color: rgb(182 201 0 / 68%);
}

.angularts-skill{
    background-color: rgb(0 27 201 / 68%)
}

.reactjs-skill {
    background-color: rgba(201, 121, 0, 0.966);
}

.nodejs-skill {
    background-color: rgba(255, 7, 7, 0.89);
}

.java-skill{
    background-color: rgba(0, 201, 201, 0.678);
}

.skill-name {
    padding: 1rem;
}

@media screen and (max-width:950px) {
    .skills-display{
        width: 90%;
    }
    .skill-progress{
        width: 25rem;
    }
}
`